import { render, staticRenderFns } from "./SearchRecent.vue?vue&type=template&id=7f7b9b08&"
import script from "./SearchRecent.vue?vue&type=script&lang=js&"
export * from "./SearchRecent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports